import React, { useRef, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  item: string;
}

const OtpInput = ({ item, ...props }: Props) => {
  const [isMaskShown, setIsMaskShown] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFocusInput = () => inputRef.current?.focus();
  const handleRemoveMask = () => setIsMaskShown(false);
  const handleShowMask = () => setIsMaskShown(true);

  const isValueAvailable = !!item;
  const showMask = isValueAvailable && isMaskShown;

  return (
    <div className="ss-relative">
      <input
        type="text"
        {...props}
        onFocus={handleRemoveMask}
        onBlur={handleShowMask}
        ref={inputRef}
      />
      {showMask && (
        <span
          onClick={handleFocusInput}
          className="ss-w-3 ss-h-3 ss-flex ss-items-center ss-justify-center ss-absolute text-[18px] ss-top-[50%] ss-left-[50%] ss-transform ss-translate-x-[-50%] ss-translate-y-[-50%]">
          <span className="ss-relative ss-top-[2px]">*</span>
        </span>
      )}
    </div>
  );
};

export default OtpInput;
